module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/green@2x.png?e11d63f3";